<template>
    <rkm-form ref="Form">
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacoes"
                    rows="6"
                    v-model="procedimentoCirurgico.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                observacoes: { max: 1000 },
            }
        },
    },
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.originalProcedimentoCirurgico.observacoes = this.procedimentoCirurgico.observacoes

                    this.$emit('save')
                })
        },
    },
    props: {
        originalProcedimentoCirurgico: { type: Object, required: true },
        procedimentoCirurgico: { type: Object, required: true },
    },
}
</script>